import * as React from "react";
import { forwardRef } from "react";
const SvgIconNavigationArrowBack = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#036FE2", fillRule: "evenodd", d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" }));
const ForwardRef = forwardRef(SvgIconNavigationArrowBack);
export default ForwardRef;
